/**
 * Created by Ning Jiang on 2021-06-28.
 */

import {WinPresentationController} from "../WinPresentationController";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {gsap} from "gsap";
import {Oktoberfest} from "../../Oktoberfest";

export class FreespinWinController extends WinPresentationController {

    constructor() {
        super("FreespinWinController", false);
    }

    protected hasWin():boolean {
        const data = Oktoberfest.model.parsedGameData;
        return data.mode != GameMode.FREESPIN && data.nextMode === GameMode.FREESPIN;
    }

    protected async createWinAnimation():Promise<any> {
        const tl = gsap.timeline();
        //#739
        /*let delay = 0.1;
        Oktoberfest.model.parsedGameData.scatterPositions!.forEach((symId, reelId) => {
            if(symId > -1) {
                const symbol = Oktoberfest.reels[reelId].getSymbol(symId);
                const symTl = gsap.timeline();
                symTl.add(symbol.playLanding());
                tl.add(symTl, delay);

            }
        });*/
        tl.to(this, {duration : 0.1}); // Add this line because the Oktoberfest server didn't give scatterPositions and the empty tl doesn't continue the promise chain.
        await Promise.resolve(tl);
        await new Promise<void>(resolve => {
            Oktoberfest.freespinIntro.show(() => {
                Oktoberfest.keypadPlugin.setZeroBetSpinCounter(Oktoberfest.model.parsedGameData.freespinsLeft);
                resolve();
            });
        });
    }
}